import posthog from 'posthog-js'
import { TRPCClientError } from '@trpc/client'

export type ErrorContext = Record<string, unknown>

// Mirror backend trpcOnError's EXPECTED_TRPC_CODES — codes that represent
// expected client-side conditions, not bugs to investigate.
const EXPECTED_TRPC_CODES = new Set(['FORBIDDEN', 'NOT_FOUND', 'CONFLICT', 'UNAUTHORIZED'])

const isExpectedTrpcError = (error: unknown): boolean => {
  if (!(error instanceof TRPCClientError)) return false
  const code = (error.data as { code?: unknown } | null | undefined)?.code
  return typeof code === 'string' && EXPECTED_TRPC_CODES.has(code)
}

// PostHog autocapture only sees uncaught errors. Use this in catch blocks
// so swallowed errors still get reported with their surrounding context.
export function captureError(error: unknown, context: ErrorContext = {}): void {
  console.error('[error]', context, error)
  if (isExpectedTrpcError(error)) return
  try {
    posthog.captureException(error, context)
  } catch {
    // never let telemetry break the caller's flow
  }
}
